import { createFileRoute } from '@tanstack/react-router';

import { ErrorsPage } from '@/pages/errors/errors-page';

export const Route = createFileRoute('/errors')({
  component: ErrorsPage,
});
